import React, { createContext, useContext, useState, useEffect } from "react";

const ServiceOrdersFiltersContext = createContext();

const STORAGE_KEY = "SO_FILTERS";
const KEEP_FLAG = "SO_KEEP";

export const ServiceOrdersFiltersProvider = ({ children }) => {
  const [filters, setFiltersState] = useState(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const setFilters = (next) => {
    setFiltersState(next);
    try {
      if (next && Object.keys(next).length) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch {}
  };

  const getStoredFilters = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const clearFilters = () => {
    setFiltersState(null);
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {}
  };

  const markKeep = () => {
    try {
      sessionStorage.setItem(KEEP_FLAG, "1");
      // console.log("markKeep -> SO_KEEP=1");
    } catch {}
  };

  const consumeKeep = () => {
    try {
      const v = sessionStorage.getItem(KEEP_FLAG);
      if (v) sessionStorage.removeItem(KEEP_FLAG);
      // console.log("consumeKeep ->", !!v);
      return Boolean(v);
    } catch {
      return false;
    }
  };

  const clearKeep = () => {
    try {
      sessionStorage.removeItem(KEEP_FLAG);
      // console.log("clearKeep -> removed SO_KEEP");
    } catch {}
  };

  useEffect(() => {
    console.log("ServiceOrdersFiltersProvider montado - filtros:", filters);
  }, [filters]);

  return (
    <ServiceOrdersFiltersContext.Provider
      value={{
        filters,
        setFilters,
        getStoredFilters,
        clearFilters,
        markKeep,
        consumeKeep,
        clearKeep
      }}
    >
      {children}
    </ServiceOrdersFiltersContext.Provider>
  );
};

export const useServiceOrdersFilters = () => useContext(ServiceOrdersFiltersContext);

